export default theme => ({
  Invoice__Detail_link: {
    color: 'black'
  }
})
